import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { colors } from "@apps/viewer/src/ts/config";

/**
 * Specification of the transition duration in milliseconds.
 */
const DURATION = 280;

/**
 * Simple css transition that'll fade and scale the content into view the first
 * time the page is being opened.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const InitialFade: React.FC<{
  in?: boolean;
  children: React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: DURATION, exit: DURATION }}
      classNames="initialFade"
      nodeRef={ref}
    >
      <div ref={ref}>
        {props.children}

        <style jsx global>{`
          .initialFade-enter > *,
          .initialFade-appear > * {
            opacity: 0.001;

            /**
                         * Apply background color, so that the initial throbber
                         * will disappear when this element is faded into view.
                         */
            background: ${colors.white};
          }

          .initialFade-enter-active > *,
          .initialFade-appear-active > * {
            opacity: 1;
            transition: opacity ${DURATION}ms linear;
          }

          .initialFade-exit > * {
            opacity: 1;
          }

          .initialFade-exit-active > * {
            opacity: 0.001;
            transition: opacity ${DURATION}ms linear;
          }

          .initialFade-exit-done > * {
            opacity: 0;
          }
        `}</style>
      </div>
    </CSSTransition>
  );
};
